import _ from "lodash";
import { useState, useEffect } from "react";
// import { useRouter } from "next/router";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { fetchPost, updatePost } from "~/redux/actions/post";
import { hasAnyRole } from "~/utils/user";

import dynamic from "next/dynamic";
import Loading from "~/components/site/Loading";

import { getCategories, showAppModal } from "~/redux/actions/app";

import { Card } from "antd";
import ItemGroup from "~/components/forms/ItemGroup";
import TagGroup from "~/components/tag/TagGroup";
import SiteLayout from "~/components/layout/SiteLayout";
import JobRulesCard from "~/components/site/JobRulesCard";
import JobTemplateCard from "~/components/site/JobTemplateCard";
import TalentJobCard from "~/components/site/TalentJobCard";
import PostPublishDropdown from "~/components/post/PostPublishDropdown";
import { FORM_LAYOUT, onInputChange } from "~/utils/form";
import lscache from "lscache";
import { postToForm } from "~/utils/post";
import {
  SAVE_POST_REQUEST,
  SAVE_DRAFT_SUCCESS,
  createDraft,
  updateDraft,
  fetchDraft,
  fetchComparePostList,
  restComparePostList,
} from "~/redux/actions/post";
import { setPostCheckedTime } from "~/redux/actions/app";

// components
import { Form, Input, Button, Tooltip } from "antd";
import ContactMethodSelection from "~/components/forms/ContactMethodSelection";
import { LoadingOutlined } from "@ant-design/icons";
import { useRouter } from "next/router";

// utils
import { postUrl } from "~/utils/route";
import TextArea from "antd/lib/input/TextArea";
import { checkOwner } from "../../../utils/app";
import {
  usePostCheckedEffect,
  useDraftCacheKey,
  useDebounceFn,
  useWarnIfUnsavedChanges,
} from "~/utils/hooks";

const Editor = dynamic({
  loader: () => import("~/components/forms/Editor"),
  loading: () => <Loading />,
  ssr: false,
});

const INITIAL_POST_INFO = {
  title: "",
  content: "",
  raw_content: "",
  category_id: "",
  remark: "",
};

let _availableCategories = null;

const Page = (props) => {
  const router = useRouter();
  const { draft_id: draftId } = router.query;
  const [post] = useState(postToForm(props.post));
  const { c } = router.query;
  const [visibility, setVisibility] = useState(props.post.visibility);
  const [data, setData] = useState();
  const draftCacheKey = useDraftCacheKey({
    type: "jobs",
    postId: post.id,
    draftId,
  });
  const isAuthor = checkOwner(props.post, props.user);
  let theMentions = null;
  const [form] = Form.useForm();

  const availableCategories = () => {
    if (!_availableCategories || _availableCategories.length === 0) {
      _availableCategories = _.filter(props.categories, (category) => {
        return (
          _.intersection(props.user.roles, category.roles).length > 0 &&
          category.kind === "work"
        );
        // return category.code === "jd" || category.code === "talent";
      });
    }
    return _availableCategories;
  };

  // props
  const category = () => {
    return _.find(props.categories, { id: state.category_id });
  };
  const [state, setState] = useState({
    ...INITIAL_POST_INFO,
    ...post,
    contact_info: _.isEmpty(post.contact_info)
      ? props.user.contact_info
      : post.contact_info,
    content_init:
      post.raw_content && post.raw_content != ""
        ? post.raw_content
        : post.content,
    category_name: "",
    // Contact method options for jobs channel
    contact_methods: post.contact_methods || [],
    email_address: post.email_address || "",
    phone_number: post.phone_number || "",
  });

  const isTalentJob = category() && category().code === "talent";
  const isJobsChannel = category() && category().code === "jobs_channel";
  const hasChangedToTalentJob =
    props.post.category.code !== "talent" && isTalentJob;

  const getTitlePlaceholder = () => {
    const currentCategory = category();
    if (currentCategory && currentCategory.code === "jobs_channel") {
      return "类型/薪资/岗位/公司主营业务，如【全职远程】15K-30K/Flutter开发/AI方向教育类软件";
    }
    return "一个拥有辨识度和创造力的标题可以帮助你获得更多阅读";
  };

  const tagGroups = () => {
    const cate = category();
    return cate ? cate.tag_groups : [];
  };

  const requiredTagGroups = () => {
    const cate = category();
    return cate ? cate.tag_groups_required || [] : [];
  };

  const isTagGroupRequired = (tagGroup) => {
    return requiredTagGroups().includes(tagGroup.code);
  };

  // utils
  const getTagIds = () => {
    const tagIds = [];
    const tagGroupCodes = tagGroups().map((group) => `${group.code}_tag_ids`);
    for (const key in state) {
      if (key.endsWith("_tag_ids") && _.includes(tagGroupCodes, key)) {
        tagIds.push(state[key]);
      }
    }
    return _.chain(tagIds).flatten().compact().value();
  };

  const getPostInfo = () => {
    return {
      title: _.trim(state.title),
      content: state.content,
      raw_content: state.raw_content,
      category_id: state.category_id,
      remark: state.remark,
      tag_ids: getTagIds(),
      contact_info: _.trim(state.contact_info),
      contributor_ids: removeMainAuthor(),
      draft_id: draftId,
      talent: hasChangedToTalentJob,
      visibility,
      contact_methods: state.contact_methods,
      email_address: _.trim(state.email_address || ""),
      phone_number: _.trim(state.phone_number || ""),
    };
  };

  const removeMainAuthor = () => {
    if (theMentions) {
      return _.remove(theMentions.validate(), function (item) {
        return item !== props.user.id;
      });
    } else {
      return [];
    }
  };

  useWarnIfUnsavedChanges(
    lscache.get(draftCacheKey),
    "有未保存的内容，确定要离开吗？"
  );

  // handles
  const handleInputChange = onInputChange({ state, setState, form });

  const handleContactMethodChange = (checkedValues) => {
    setState({
      ...state,
      contact_methods: checkedValues,
    });
    form.setFieldValue("contact_methods", checkedValues);
  };
  const handleContentChange = (value) => {
    setState({
      ...state,
      content: value.html,
      raw_content: value.text,
    });
    form.setFieldValue("raw_content", value.text);
    form.validateFields(["raw_content"]);

    if (value.text) {
      lscache.set(
        draftCacheKey,
        {
          content: value.html,
          raw_content: value.text,
        },
        10080
      );
    } else {
      lscache.remove(draftCacheKey);
    }
    if (draftId) {
      debouncedUpdateDraft();
    }
  };

  const debouncedUpdateDraft = useDebounceFn(
    () =>
      props.updateDraft(
        props.token,
        props.draftId,
        getPostInfo(),
        draftCacheKey,
        false
      ),
    3000
  );

  const handleSubmit = (data) => {
    setData(data);
    props.updatePost(props.token, post.id, data, draftCacheKey);
  };

  const handleSavePost = () => {
    const myEle = props.user.ele;
    if (myEle < 0) {
      props.showAppModal("RestrictedOperationModal", {
        operation: "发帖",
      });
      return;
    }

    handleSubmit(getPostInfo());
  };

  const handleSaveDraft = async () => {
    form.setFieldsValue(state);
    await form.validateFields();

    if (draftId) {
      props.updateDraft(props.token, draftId, getPostInfo(), draftCacheKey);
    } else {
      props.createDraft(
        props.token,
        {
          ...getPostInfo(),
          post_id: _.get(props, "post.id"),
        },
        draftCacheKey,
        "job"
      );
    }
  };
  const handleCompareTitle = () => {
    const params = {
      compared_title: state.title,
      id: state.id || "",
    };
    props.fetchComparePostList(props.token, params);
  };

  const pageSider = (
    <div>
      {isTalentJob && <TalentJobCard />}
      {isTalentJob ? <JobTemplateCard /> : <JobRulesCard />}
    </div>
  );

  useEffect(() => {
    if (draftId) {
      props.fetchDraft(props.token, draftId);
    } else {
      const changes = {};
      if (!state.category_id && props.categories.length > 0) {
        if (props.isJob) {
          changes.category_id = _.find(
            props.categories,
            (category) => category.code === "jd"
          ).id;
        } else {
          changes.category_id = _.get(props.categories, "[0].id");
        }
      }

      const draftContent = lscache.get(draftCacheKey);

      if (draftContent && !post.id) {
        changes.raw_content = draftContent.raw_content;
        changes.content_init = draftContent.raw_content;
        changes.content = draftContent.content;
      }

      const newState = { ...state, ...changes };
      setState(newState);
      form.setFieldsValue(newState);
    }
  }, [props.categories]);

  useEffect(() => {
    if (props.draft) {
      const postInfo = postToForm(props.draft);
      const newState = {
        ...state,
        ...postInfo,
        content_init:
          postInfo.raw_content && postInfo.raw_content != ""
            ? postInfo.raw_content
            : postInfo.content,
      };
      setState(newState);
      form.setFieldsValue(newState);
    }
  }, [props.draft]);

  useEffect(() => {
    props.getCategories();
    props.restComparePostList();
  }, []);

  useEffect(() => {
    if (!props.categories) return;
    const category = _.find(
      props.categories,
      (category) => category.code === c
    );
    if (category) {
      setState({ ...state, ...{ category_id: category.id } });
      form.setFieldValue("category_id", category.id);
    }
  }, [c, props.categories]);

  const submitting =
    props.request[SAVE_POST_REQUEST] || props.request[SAVE_DRAFT_SUCCESS];

  // views
  const renderContactFormItem = () => {
    if (isJobsChannel) {
      return (
        <ContactMethodSelection
          contactMethods={state.contact_methods}
          emailAddress={state.email_address}
          phoneNumber={state.phone_number}
          onContactMethodChange={handleContactMethodChange}
          onInputChange={handleInputChange}
          form={form}
        />
      );
    }
    return (
      <Form.Item
        label="联系方式"
        name="contact_info"
        rules={[{ required: true, message: "请填写联系方式" }]}
      >
        <Input
          name="contact_info"
          value={state.contact_info}
          placeholder={"请填写联系方式"}
          onChange={handleInputChange}
        />
        {isTalentJob && (
          <span style={{ fontSize: 12, color: "#9b9b9b" }}>
            （必填）建议留下你的微信ID，稍后人才库管理员会添加你，沟通审核，协助招聘。
          </span>
        )}
      </Form.Item>
    );
  };

  usePostCheckedEffect({ ...props, postId: post.id, data });

  return (
    <SiteLayout
      pageTitle="编辑招聘"
      pageSider={pageSider}
    >
      <Card>
        <h1 className="page-title">编辑招聘</h1>

        {props.user && (
          <div>
            <Form
              {...FORM_LAYOUT}
              onSubmit={handleSubmit}
              form={form}
              initialValues={state}
            >
              {/* <Form.Item
                label="选择分类"
                name="category_id"
                rules={[{ required: true, message: "请选择分类" }]}
              >
                <ItemGroup
                  name="category_id"
                  items={availableCategories()}
                  selected={state.category_id}
                  onChange={handleInputChange}
                />
              </Form.Item> */}

              <Form.Item
                label="标题"
                name="title"
                rules={[
                  { required: true, message: "请输入标题" },
                  { min: 5, max: 100, message: "标题长度应在5-100个字符之间" },
                ]}
              >
                <Input
                  name="title"
                  value={state.title}
                  placeholder={getTitlePlaceholder()}
                  onChange={handleInputChange}
                  onBlur={handleCompareTitle}
                  suffix={props.compareLoading && <LoadingOutlined />}
                />
                {props.comparePostList && props.comparePostList.length > 0 && (
                  <Card
                    bordered={false}
                    style={{ marginBottom: "0px" }}
                    bodyStyle={{ padding: "10px 0px 0px 0px" }}
                  >
                    <p>
                      <b>相似贴子：</b>
                    </p>
                    {props.comparePostList.map((post) => (
                      <p key={post.id}>
                        <a
                          href={postUrl(post)}
                          target="_blank"
                          rel="noreferrer"
                        >
                          {post.title}
                        </a>
                      </p>
                    ))}
                  </Card>
                )}
              </Form.Item>

              <Form.Item
                label="正文"
                name="raw_content"
                rules={[
                  { required: true, message: "请输入正文" },
                  { min: 10, message: "正文长度应在10个字符以上" },
                ]}
              >
                <Editor
                  name="raw_content"
                  defaultValue={state.content_init}
                  value={state.raw_content}
                  token={props.token}
                  onChange={handleContentChange}
                  title={state.title}
                />
                <Tooltip>
                  <a
                    href="https://eleduck.com/posts/OGfw4Z"
                    target="_blank"
                    style={{ color: "#F9BA48" }}
                    rel="noreferrer"
                  >
                    不太会用这个编辑器？看这里：)
                  </a>
                </Tooltip>
              </Form.Item>

              {renderContactFormItem()}

              {hasChangedToTalentJob && (
                <Form.Item label="备注">
                  <TextArea
                    name="remark"
                    value={state.remark}
                    onChange={handleInputChange}
                  />
                </Form.Item>
              )}

              {tagGroups().map((tagGroup) => (
                <Form.Item
                  label={tagGroup.name}
                  key={tagGroup.id}
                  name={`${tagGroup.code}_tag_ids`}
                  rules={[
                    {
                      required: isTagGroupRequired(tagGroup),
                      message: `请选择${tagGroup.name}`,
                    },
                  ]}
                >
                  <TagGroup
                    name={`${tagGroup.code}_tag_ids`}
                    tagGroup={tagGroup}
                    selected={state[`${tagGroup.code}_tag_ids`]}
                    onChange={handleInputChange}
                  />
                </Form.Item>
              ))}
              {isTalentJob ? (
                <Form.Item label={" "}>
                  <div
                    style={{
                      color: "#51b52e",
                      fontSize: "14px",
                      marginBottom: 25,
                    }}
                  >
                    我们会在24小时内会添加您的微信，并处理您的申请。
                  </div>
                </Form.Item>
              ) : (
                <Form.Item label={" "}>
                  <div
                    style={{
                      color: "#51b52e",
                      fontSize: "14px",
                      marginBottom: 25,
                    }}
                  >
                    提示：发布后，记得
                    <span
                      style={{ color: "#f9ba48", cursor: "pointer" }}
                      onClick={() =>
                        window.open("https://eleduck.com/posts/82f487")
                      }
                    >
                      下载 APP
                    </span>
                    ，方便及时收到评论的回复和提醒。如招满或暂停招聘，请记得更新帖子标题为“已招满/已结束”等字样，避免用户浪费电量，引发投诉。
                  </div>
                </Form.Item>
              )}

              <Form.Item label=" ">
                <div className="form-actions">
                  <Button
                    type="primary"
                    htmlType="button"
                    disabled={submitting}
                    className="br-10"
                    onClick={handleSaveDraft}
                  >
                    存草稿
                  </Button>
                  {hasChangedToTalentJob ? (
                    <Button
                      type="primary"
                      htmlType="button"
                      disabled={submitting}
                      onClick={handleSavePost}
                    >
                      提交申请
                    </Button>
                  ) : isAuthor && props.post.visibility !== "hidden" ? (
                    <PostPublishDropdown
                      form={form}
                      post={props.post}
                      category={category()}
                      isAuthor={isAuthor}
                      submitting={submitting}
                      setVisibility={setVisibility}
                      handleSavePost={handleSavePost}
                    />
                  ) : (
                    <Button
                      type="primary"
                      htmlType="button"
                      disabled={submitting}
                      onClick={handleSavePost}
                    >
                      发布
                    </Button>
                  )}
                </div>
              </Form.Item>
            </Form>

            <style jsx>
              {`
                .form-actions button {
                  margin-right: 20px;
                }
              `}
            </style>
          </div>
        )}
      </Card>
    </SiteLayout>
  );
};

const mapStateToProps = (state) => ({
  token: state.user.token,
  user: state.user.user,
  categories: state.app.categories,
  request: state.app.request,
  draft: state.post.draft,
  comparePostList: state.post.comparePostList,
  compareLoading: state.post.compareLoading,
  postCheckedTime: state.app.postCheckedTime,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updatePost,
      getCategories,
      createDraft,
      updateDraft,
      fetchDraft,
      fetchComparePostList,
      restComparePostList,
      setPostCheckedTime,
      showAppModal,
    },
    dispatch
  );

Page.requireUser = () => true;

Page.getInitialProps = async (ctx) => {
  const { id } = ctx.query;
  const state = ctx.store.getState();
  const user = state.user.user;

  const post = await fetchPost(state.user.token, id);
  const isAdmin = hasAnyRole(user, ["admin", "editor"]);
  if (post.user.id === state.user.user.id || isAdmin) {
    return { post };
  } else {
    const error = new Error("not found");
    error.statusCode = 404;
    throw error;
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(Page);
